// extracted by mini-css-extract-plugin
export default {"link":"PM-z","disabled":"QM-z"};